// Montessori
import React from 'react';
import { MootCourt2026 } from '../views';

const Montessoripage = () => {
  return <MootCourt2026/>;
};

export default Montessoripage;